import { createContext } from 'react';

export type BankSuccessCtx = {
  showConnectBankSuccessAlert: boolean;
};

const BankSuccessContext = createContext<BankSuccessCtx>({
  showConnectBankSuccessAlert: false,
});

export default BankSuccessContext;
